import React from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";

const Home = () => {
  return (
    <div>
      <Section1></Section1>
      <Section2></Section2>
    </div>
  );
};

export default Home;
